<page-title [title]="title"></page-title>
<p>Veja abaixo as instituições em que você está vinculado, eles podem realizar alterações em sua agenda:</p>
<mat-tab-group>
    <mat-tab *ngFor="let tab of tabs" [label]="tab.title">     
        <div class="col-xs-12 col-lg-6 "  *ngFor="let organization of getContentPaginated(tab.id)">
           
            <mat-card  (click)="openOrganizationDetailForm(organization)">               
                <div class="col-xs-12 col-md-12">
                    <div class="content">{{organization.organization_name }} <br> {{ getCity(organization.organization_id) ?? 'Sem Localização' }}</div>
                </div>      
            </mat-card>
        </div> 
        <page-pagination  [pagination]="pagination"  (callback)="paginate($event)" *ngIf="showPagination(tab.id)"></page-pagination>       
    </mat-tab>    
  </mat-tab-group>
  <div class="actions">    
    <button  mat-flat-button color="primary" (click)="openForm()" [disabled]="loading" 
    >Vincular nova instituição</button>
  </div>
  